<template>
    <el-dialog :before-close="close" :visible.sync="visible" title="选择素材" width="800px">
        <el-tree
            :load="loadTreeNode"
            :props="treeProps"
            @check-change="checkTree"
            lazy
            node-key="labelId"
            ref="tree"
            show-checkbox
        >
            <template slot-scope="{ node }">
                <span style="font-size: 16px;">{{ node.label }}</span>
            </template>
        </el-tree>
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handle" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('installDevice');

export default {
    props: {
        visible: Boolean,
        checkKeys: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            treeProps: { label: 'name', isLeaf: 'leaf' },
        };
    },
    methods: {
        ...mapActions(['getLabelList', 'getFileList']),
        close() {
            this.$emit('on-close', false);
        },
        handle() {
            this.close();
        },
        async loadTreeNode(node, resolve) {
            if (node.level === 0) {
                const data = await this.getLabelList();
                const list = data.labels.map(item => {
                    item.name = item.labelName;
                    return item;
                });
                return resolve(list);
            } else if (node.level === 1) {
                const params = { labelId: node.data.labelId };
                const data = await this.getLabelList(params);
                const list = data.labels.map(item => {
                    item.name = item.labelName;
                    return item;
                });
                return resolve(list);
            } else {
                const params = { labelId: node.data.labelId };
                const data = await this.getFileList(params);
                const list = data.files.map(item => {
                    item.name = item.fileName;
                    item.labelId = item.fileId;
                    item.leaf = true;
                    return item;
                });
                // this.$refs.tree.setCheckedKeys(this.checkKeys);
                return resolve(list);
            }
        },
        checkTree(data, checked, indeterminate) {
            console.log(data, checked, indeterminate);
        },
    },
};
</script>

<style></style>
